/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var code = require("vscode");
var ProtocolCodeLens = /** @class */ (function (_super) {
    __extends(ProtocolCodeLens, _super);
    function ProtocolCodeLens(range) {
        return _super.call(this, range) || this;
    }
    return ProtocolCodeLens;
}(code.CodeLens));
exports.default = ProtocolCodeLens;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vscode-base-languageclient/lib/protocolCodeLens.js
// module id = 238
// module chunks = 0